export default {
  SetVisibleRange: 'Set Visible Scope',
  Confirm: 'OK',
  Cancel: 'Cancel',
  Import: 'Import',
  Close: 'Close',
  AddPerson: 'AddPerson',
  Allemployees: 'All employees',
  Someemployees: 'Specific employees',
  SelectPerson: 'Select Employee',
  ImportPersonList: 'Import List',
  DownLoadPersonList: 'DownLoad List',
  Tips: 'Tips',
  DownLoadProfile: 'DownLoad Profile',
  ImportFile: 'Import File',
  PleaseSelectFile: 'Please Select File',
  SelectFile: 'Select File',
  ContinueUploading: 'Add More',
  ClearSelected: 'Clear List',
  DefaultSelectPersonSearchPlaceholder: 'Search by name, department, role',
  Selected: 'Selected',
  ToSelect: 'ToSelect',
  TabGroup: 'Organization',
  TabRole: 'Role',
  UserGroup: 'User Group',
  Administrator: 'Administrator',
  SelectTips1:
    '1. The maximum number of selected entries (person/department) is 500.',
  SelectTips2:
    '2. After you click OK, the platform will deduplicate the employee accounts to ensure that the employees are not added repeatedly.',
  SelectTipsOK: 'After you click OK, the platform will overwrite the original data based on the current date range.',
  ImportTips: 'A maximum of 500 data records can be imported. ',
  DownloadTemplate: 'Download the template.',
  ErrorTipsNoMeet: 'A file that does not meet the template requirements exists. Please check.',
  ErrorTipsEmpty: 'An empty file exists. Please check.',
  ErrorTipsIncorrect: 'The file type is incorrect.',
  ErrorTipsNoEmployee: 'Select an employee before saving.',
  ErrorTipsLimmit: 'Select a maximum of 500 data records.',
  ErrorTipsNoChange: 'No data change.',
  SaveSuccess: 'Saved successfully.',
  SlectLimmit: 'The number of the selected employees of the department cannot exceed the upper limit 500.',
  Imported: 'Imported',
  Succeeded: 'succeeded',
  Duplicate: 'duplicate',
  Failed: 'failed',
  YouCan: 'You can',
  DownLoadDetailList: 'download the details list',
  ModifyUpload: 'modify it, and upload it again.',
  TipsReWrite: 'If the imported file contains duplicate content, the system automatically deduplicates the content.',
  TipsImport: 'After you click Import, the latest list will overwrite the previous settings.',
  GetAllUserGroupInfoRejectTips: 'The data is incorrect. The total number of user groups cannot exceed 500.',
  FileNotMeetRequire: 'Files that do not meet the template requirements exist. Please check!',
  EmptyFileExists: 'Empty file exists. Please check.',
  FileTypeError: 'The file type is incorrect.',
  ToManyToSelectAll:
    'The current department has too many employees. Please select the department in the upper-level organization.',
  Invalidate: 'Invalidate',
  OnlyDataRange : 'Only application administrators and developers can set the data range.',
  SetDataRange: 'Set Data Range',
};
